"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDbGuideMenu = exports.defaultDbGuideMenuItem7 = exports.defaultDbGuideMenuItem6 = exports.defaultDbGuideMenuItem5 = exports.defaultDbGuideMenuItem4 = exports.defaultDbGuideMenuItem3 = exports.defaultDbGuideMenuItem2 = exports.defaultDbGuideMenuItem1 = exports.defaultDbGuideMenuChildrenItem8 = exports.defaultDbGuideMenuChildrenItem7 = exports.defaultDbGuideMenuChildrenItem6 = exports.defaultDbGuideMenuChildrenItem5 = exports.defaultDbGuideMenuChildrenItem4 = exports.defaultDbGuideMenuChildrenItem3 = exports.defaultDbGuideMenuChildrenItem2 = exports.defaultDbGuideMenuChildrenItem1 = void 0;
var DbGuideState_1 = require("@/pages/dbguide/states/DbGuideState");
exports.defaultDbGuideMenuChildrenItem1 = {
    title: 'Amalfi',
    type: DbGuideState_1.DbGuidePlaceType.DEVELOPMENT,
    key: 'amalfi',
};
exports.defaultDbGuideMenuChildrenItem2 = {
    title: 'Seabee Lane',
    type: DbGuideState_1.DbGuidePlaceType.DEVELOPMENT,
    key: 'seabeelane',
};
exports.defaultDbGuideMenuChildrenItem3 = {
    title: 'Discovery College',
    type: DbGuideState_1.DbGuidePlaceType.SCHOOL,
    key: 'discoverycollege',
};
exports.defaultDbGuideMenuChildrenItem4 = {
    title: 'DBIS',
    type: DbGuideState_1.DbGuidePlaceType.SCHOOL,
    key: 'dbis',
};
exports.defaultDbGuideMenuChildrenItem5 = {
    title: 'Ferry Services',
    type: DbGuideState_1.DbGuidePlaceType.TRANSPORT,
    key: 'ferry',
};
exports.defaultDbGuideMenuChildrenItem6 = {
    title: 'Internal Buses',
    type: DbGuideState_1.DbGuidePlaceType.TRANSPORT,
    key: 'internalbus',
};
exports.defaultDbGuideMenuChildrenItem7 = {
    title: 'Lantau Boat Club',
    type: DbGuideState_1.DbGuidePlaceType.SPORT,
    key: 'lantauboatclub',
};
exports.defaultDbGuideMenuChildrenItem8 = {
    title: 'Banking',
    type: DbGuideState_1.DbGuidePlaceType.BUSINESS_DIRECTORY,
    key: 'banking',
};
exports.defaultDbGuideMenuItem1 = {
    title: 'Developments',
    type: DbGuideState_1.DbGuidePlaceType.DEVELOPMENT,
    key: 'developments',
    isOpened: false,
    icon: 'fas fa-building',
    children: [
        exports.defaultDbGuideMenuChildrenItem1,
        exports.defaultDbGuideMenuChildrenItem2,
    ],
};
exports.defaultDbGuideMenuItem2 = {
    title: 'Schools',
    type: DbGuideState_1.DbGuidePlaceType.SCHOOL,
    key: 'schools',
    isOpened: false,
    icon: 'fas fa-school',
    children: [
        exports.defaultDbGuideMenuChildrenItem3,
        exports.defaultDbGuideMenuChildrenItem4,
    ],
};
exports.defaultDbGuideMenuItem3 = {
    title: 'Emergency',
    type: DbGuideState_1.DbGuidePlaceType.EMERGENCY,
    key: 'emergency',
    isOpened: false,
    icon: 'fas fa-hospital',
    children: null,
};
exports.defaultDbGuideMenuItem4 = {
    title: 'Transport',
    type: DbGuideState_1.DbGuidePlaceType.TRANSPORT,
    key: 'transport',
    isOpened: false,
    icon: 'fas fa-bus',
    children: [
        exports.defaultDbGuideMenuChildrenItem5,
        exports.defaultDbGuideMenuChildrenItem6,
    ],
};
exports.defaultDbGuideMenuItem5 = {
    title: 'Sports & Recreation',
    type: DbGuideState_1.DbGuidePlaceType.SPORT,
    key: 'sport',
    isOpened: false,
    icon: 'fas fa-football-ball',
    children: [
        exports.defaultDbGuideMenuChildrenItem7,
    ],
};
exports.defaultDbGuideMenuItem6 = {
    title: 'Useful Links',
    type: DbGuideState_1.DbGuidePlaceType.USEFUL_LINK,
    key: 'usefullink',
    isOpened: false,
    icon: 'fas fa-info',
    children: null,
};
exports.defaultDbGuideMenuItem7 = {
    title: 'Business Directory',
    type: DbGuideState_1.DbGuidePlaceType.BUSINESS_DIRECTORY,
    key: 'business',
    isOpened: false,
    icon: 'fas fa-address-card',
    children: [
        exports.defaultDbGuideMenuChildrenItem8,
    ],
};
exports.defaultDbGuideMenu = {
    items: [
        exports.defaultDbGuideMenuItem1,
        exports.defaultDbGuideMenuItem2,
        exports.defaultDbGuideMenuItem3,
        exports.defaultDbGuideMenuItem4,
        exports.defaultDbGuideMenuItem5,
        exports.defaultDbGuideMenuItem6,
        exports.defaultDbGuideMenuItem7,
    ],
};
